import { render } from "./cokies.vue?vue&type=template&id=b3b209a4&scoped=true"
import script from "./cokies.vue?vue&type=script&lang=js"
export * from "./cokies.vue?vue&type=script&lang=js"

import "./cokies.vue?vue&type=style&index=0&id=b3b209a4&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b3b209a4"]])

export default __exports__